/* global React */
import LinkHOC from '@platform/react/hoc/link'
import Decorated from '../Text/Decorated'

const DecoratedLink = LinkHOC(React.forwardRef(Decorated))

export default DecoratedLink
